/**
 * Mobile TOC Drawer
 *
 * Slides a table-of-contents panel in from the right on small screens.
 * The drawer only activates when the markup exists; on desktop it is hidden
 * via CSS so no JS wiring is needed there.
 */

export function initResourceTocDrawer() {
	const drawer  = document.getElementById( 'toc-drawer' );
	const toggle  = document.getElementById( 'toc-drawer-toggle' );

	if ( ! drawer || ! toggle ) {
		return;
	}

	// Inject a backdrop element once, append to body.
	const backdrop = document.createElement( 'div' );
	backdrop.className  = 'resource-single__toc-backdrop';
	backdrop.setAttribute( 'aria-hidden', 'true' );
	document.body.appendChild( backdrop );

	// ── State helpers ────────────────────────────────────────────────────────

	function isOpen() {
		return drawer.classList.contains( 'is-open' );
	}

	function open() {
		drawer.classList.add( 'is-open' );
		backdrop.classList.add( 'is-visible' );
		toggle.setAttribute( 'aria-expanded', 'true' );
		// Prevent body from scrolling behind the open panel.
		document.body.style.overflow = 'hidden';
	}

	function close() {
		drawer.classList.remove( 'is-open' );
		backdrop.classList.remove( 'is-visible' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		document.body.style.overflow = '';
	}

	// ── Event listeners ──────────────────────────────────────────────────────

	toggle.addEventListener( 'click', function () {
		if ( isOpen() ) {
			close();
		} else {
			open();
		}
	} );

	// Close when the backdrop is clicked.
	backdrop.addEventListener( 'click', close );

	// Close when a TOC link is clicked (let the browser jump to the section).
	drawer.querySelectorAll( '.block-table-of-contents__link' ).forEach( function ( link ) {
		link.addEventListener( 'click', function () {
			close();
		} );
	} );

	// Close on Escape.
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && isOpen() ) {
			close();
			toggle.focus();
		}
	} );

	// Re-show body scroll if the viewport crosses into desktop while the drawer
	// is open (e.g. device rotation).
	const desktopMq = window.matchMedia( '(min-width: 1024px)' );
	desktopMq.addEventListener( 'change', function ( e ) {
		if ( e.matches && isOpen() ) {
			close();
		}
	} );
}
